import React, { FC, useState } from "react"
import Button from "@components/Button"
import InputField from "@components/FormFields/InputField"
import * as yup from "yup"
import { useForm } from "react-hook-form"
import jsonp from "jsonp"
import { FormMessageProps } from "@components/FormMessage/types"
import FormMessage from "@components/FormMessage"
import type { NewsLetterSignUpProps } from "./types"
import { ActionWrapper, InnerWrapper, NewsLetterSignUpWrapper, Subtitle, TextWrapper, Title } from "./styles"
import { yupResolver } from "@hookform/resolvers/yup";
import { emailRequired } from "@utils/validation";

const schema = yup.object({
    email: emailRequired()
})

type FormData = yup.InferType<typeof schema>

const NewsLetterSignUp: FC<NewsLetterSignUpProps> = ({
    title,
    subtitle
}) => {
    const [formMessage, setFormMessage] = useState<FormMessageProps | null>(null)
    const { register, handleSubmit, formState: { errors } } = useForm<FormData>({
        resolver: yupResolver(schema)
    })

    const onSubmit = async (values: FormData) => {
        setFormMessage(null)
        const subscribeUrl = `${process.env.GATSBY_MAILCHIMP_URL}&EMAIL=${encodeURIComponent(values.email)}`

        jsonp(
            subscribeUrl,
            {
                param: "c"
            },
            (err: string, data: {result: string, msg: string}) => {
                if (err) {
                    setFormMessage({
                        type: "error",
                        message: err
                    })
                } else if (data.result !== "success") {
                    setFormMessage({
                        type: "error",
                        message: data.msg
                    })
                } else {
                    setFormMessage({
                        type: "success",
                        message: data.msg
                    })
                }
            }
        )
    }

    return <NewsLetterSignUpWrapper>
        <InnerWrapper>
            {formMessage && <FormMessage dense style={{ width: "100%" }} {...formMessage} />}
            <TextWrapper>
                <Title>{title}</Title>
                <Subtitle>{subtitle}</Subtitle>
            </TextWrapper>
            <ActionWrapper onSubmit={handleSubmit(onSubmit)}>
                <InputField
                    type="email"
                    placeholder="Vul hier je emailadres in"
                    id="email"
                    {...register("email")}
                    error={errors?.email?.message}
                />
                <Button
                    type="submit"
                    color="red"
                >
                    Schrijf je in
                </Button>
            </ActionWrapper>
        </InnerWrapper>
    </NewsLetterSignUpWrapper>
}

export default NewsLetterSignUp
